export enum EmissionPointsRequestStatusAction {
  Load = '[EmissionPoints] [Request Status] Load',
  Success = '[EmissionPoints] [Request Status] Success',
  Error = '[EmissionPoints] [Request Status] Error',
}
